import React from "react";
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
      <div className="loader-icon"></div>
    </div>
    // <div class="lds-roller">
    //   <div></div>
    //   <div></div>
    //   <div></div>
    //   <div></div>
    //   <div></div>
    //   <div></div>
    //   <span class="lds-logo"></span>
    // </div>
  );
};

export default Spinner;
